/**
 * This object requires a primary definition for each constant when the keys do not
 * match the constants and there is more than one definition for a constant.
 */
var standardQualification = 'This service may not be available in all areas. We will need to perform additional checks after you sign up to make sure we can provide this service to you.'

var types = {
    ADSL1: {
        constant: 'ADSL',
        description: 'ADSL up to 8000/384kbps with National coverage',
        group: 'ADSL 8000',
        image: require('../images/service-icon-adsl.png'),
        name: 'ADSL1',
        primary: true,
        process: false,
        qualification: standardQualification,
        type: 'ADSL1'
    },
    ADSL2D: {
        constant: 'ADSL2',
        description: 'ADSL2+ delivered directly via our network partners at selected exchanges',
        group: 'ADSL2',
        image: require('../images/service-icon-adsl.png'),
        name: 'ADSL2+ Direct',
        process: false,
        qualification: standardQualification,
        type: 'ADSL2D'
    },
    ADSL2E: {
        constant: 'ADSL2',
        description: 'National coverage via the Telstra broadband network with all the same features',
        group: 'ADSL2 TW',
        image: require('../images/service-icon-adsl.png'),
        name: 'ADSL2+ Extend',
        primary: true,
        process: false,
        qualification: standardQualification,
        type: 'ADSL2E'
    },
    COLO: { constant: 'COLO', name: 'Co-location' },
    DEDICATED_HOSTING: { constant: 'DEDICATED_HOSTING', name: 'Virtual Servers' },
    DOMAIN: { constant: 'DOMAIN', name: 'Domain Names' },
    DNS: { constant: 'DNS', name: 'DNS Hosting' },
    FAX_TO_EMAIL: { constant: 'FAX_TO_EMAIL', name: 'Fax to Email' },
    HOSTING: {
        constant: 'HOSTING',
        description: 'Website Hosting with cPanel',
        image: require('../images/service-icon-shared-hosting.png'),
        name: 'Hosting',
        process: false,
        type: 'HOSTING'
    },
    INMAIL: { constant: 'INMAIL', name: 'EDM' },
    IPN: { constant: 'IPN', name: 'IPN' },
    METRO: { constant: 'METRO', name: 'Symmetrical' },
    MISC: { constant: 'MISC', name: 'Miscellaneous' },
    NAKEDADSL2: {
        constant: 'ADSL2',
        description: 'ADSL2+ up to 24/1Mbps with no phone line rental required',
        group: 'Naked ADSL2',
        image: require('../images/service-icon-adsl.png'),
        name: 'Naked ADSL2+',
        process: false,
        qualification: standardQualification,
        type: 'NAKEDADSL2'
    },
    NAKEDVDSL: {
        constant: 'TRANSACT',
        description: 'Super fast VDSL2 up to 80/20Mbit in the ACT region',
        group: 'Naked VDSL',
        image: require('../images/service-icon-transact.png'),
        name: 'Naked VDSL2',
        process: false,
        qualification: standardQualification,
        type: 'NAKEDVDSL'
    },
    NBN: {
        constant: 'NBN',
        description: 'Broadband on the National Broadband Network',
        group: 'NBN',
        image: require('../images/service-icon-nbn.png'),
        name: 'NBN',
        primary: true,
        process: false,
        qualification: standardQualification,
        type: 'NBN'
    },
    PHONE: { constant: 'PHONE', name: 'Voice' },
    SSL: { constant: 'SSL', name: 'SSL Certificates' },
    TRANSACT: {
        constant: 'TRANSACT',
        description: 'Broadband on the Vision Network',
        group: 'Vision',
        image: require('../images/service-icon-transact.png'),
        name: 'Vision',
        primary: true,
        process: true,
        qualification: standardQualification,
        type: 'TRANSACT'
    },
    WEBDEV: { constant: 'WEBDEV', name: 'Web Development' },
    WIRELESS: { constant: 'WIRELESS', name: 'Wireless Internet' },
};

function getType(type) {
    if (types.hasOwnProperty(type)) {
        return types[type];
    }

    return null;
}

function getTypeByConstant(constant) {
    const keys = Object.keys(types).filter(t => types[t].constant === constant);

    if (keys.length === 1) {
        return types[keys[0]];
    }

    return types[keys.filter(t => types[t].primary)[0]];
}

function getTypeName(typeConst) {
    var type = getType(typeConst);

    if (type) {
        return type.name;
    }

    return typeConst;
}

module.exports = { getType, getTypeByConstant, getTypeName };



// WEBPACK FOOTER //
// ./app/constants/ServiceTypes.js